import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-contest-form-error',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './contest-form-error.html',
  styleUrl: './contest-form-error.css',
})
export class ContestFormError {}
